import React, { useContext, useEffect } from 'react';
import { ProviderSalesContext } from '../contexts/ProviderSalesContext';
import ordersPathTo from '../utils/Api/ordersPathTo';
import { useNavigate } from 'react-router-dom';
import { Box, Button, ButtonBase, Divider, Switch, Typography } from '@mui/material';
import { currency } from './building_blocks/Currency';
import AddTaskIcon from '@mui/icons-material/AddTask';
import SnackbarContext from '../contexts/SnackbarContext';

const SalesList = ({ value, index }) => {
  const { salesList, updateSalesList, updateProviderSale } = useContext(ProviderSalesContext);
  const navigate = useNavigate();

  const { openSnackbar, openConfirmDialog } = useContext(SnackbarContext);

  useEffect(() => {
    if (salesList.length === 0 && value === index) {
      ordersPathTo.sales_list().then((response) => {
        updateSalesList(response.data.orders)
      })
    }
  }, [salesList.length, value, index])

  const handleAcceptOrder = async (event, sale) => {
    event.preventDefault();
    try {
      const updatedSale = await ordersPathTo.accept_order(sale.id);
      console.log(updatedSale);
      updateProviderSale(updatedSale.data);
      openSnackbar("Pedido aceito! Logo um entregador entregará o pedido", "success")
    } catch (error) {
      console.error('Error updating sale:', error);
    }
  };

  const handleRejectOrder = async (event, sale) => {
    event.preventDefault();
    openConfirmDialog(
      'Você tem certeza que deseja rejeitar este pedido? Não tem problema esperar um pouco antes de aceitar!',
      async () => {
        try {
          const updatedSale = await ordersPathTo.reject_order(sale.id);
          updateProviderSale(updatedSale.data);
          openSnackbar("Pedido rejeitado! O cliente será estornado", "error")
        } catch (error) {
          console.error('Error updating sale:', error);
        }
      }
    );
  };

  if (salesList.length === 0) {
    return (
      <Box>
        <Typography>Carregando...</Typography>
      </Box>
    );
  }

  return (
    <Box>
      {salesList.map((sale, index) => (
        <Box key={sale.id}>
          <Box m={2} display="flex" sx={{width: "100%", height: '100%'}}>
            <Box sx={{width: "100%"}}>
              <Typography mr={2} textAlign="left" variant="body2"><b>{sale.title}</b></Typography>
              
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography mt={1} mb={1} sx={{color: '#555'}} textAlign="left" variant="body2">
                  <b>{currency(sale.total_amount)}</b>
                </Typography>
                {/* <Typography mt={1} mb={1} sx={{color: '#555'}} textAlign="left" variant="body2">
                  <b>Status: {sale.status}</b>
                </Typography> */}
                <Typography mt={1} mb={1} sx={{color: '#555'}} textAlign="right" variant="body2">
                  <b>{sale.date}</b>
                </Typography>
              </Box>

              <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                {sale.order_items.map((item, index) => (
                  <Box key={index}>
                    <Typography mt={1} mb={1} sx={{color: '#555'}} textAlign="center" variant="body2">
                      <b>{item.quantity}x {item.title}</b>
                    </Typography>
                  </Box>
                ))}
              </Box>

              {sale.status === 'pending' && (
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                  <Button variant="contained" color="primary" onClick={(event) => handleAcceptOrder(event, sale)}>Aceitar</Button>
                  <Button variant="outlined" color="error" onClick={(event) => handleRejectOrder(event, sale)}>Rejeitar</Button>
                </Box>
              )}

            </Box>
          </Box>
          {salesList.length !== index + 1 && (
            <Divider variant="middle"/>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default SalesList
